const normalizeValue = (value) => String(value || '').trim();

export const normalizeExamStatus = (status) => normalizeValue(status).replace(/\s+/g, '_').toUpperCase();

export const getExamDefinitionId = (exam = {}) => normalizeValue(
  exam?.exam?.primaryId
  || exam?.examId
  || exam?.primaryId
);

export const isQuizExam = (exam = {}) => (
  normalizeValue(exam?.subType || exam?.exam?.subType).toUpperCase() === 'QUIZ'
);

export const isPassingEvaluatedExam = (exam = {}) => {
  const status = normalizeExamStatus(exam?.status);
  const gradeLevel = normalizeValue(exam?.grade?.level || exam?.gradeLevel).toUpperCase();
  return status === 'EVALUATED' && exam?.grade?.passFlag !== false && gradeLevel !== 'FAIL';
};

export const getExamCompletionDate = (exam = {}) => (
  exam?.modifiedDate
  || exam?.effectiveDate?.effectiveEndDate
  || exam?.effectiveDate?.localEndDate
  || exam?.completionDate
  || null
);

export const getRequiredExamDefinitions = (curriculum = {}) => {
  const userExams = Array.isArray(curriculum?.userExamsList) ? curriculum.userExamsList : [];
  const examDefinitions = Array.isArray(curriculum?.examsList) ? curriculum.examsList : [];
  const source = userExams.length ? userExams : examDefinitions;
  return source.filter((exam) => exam && !isQuizExam(exam));
};

export const resolveRequiredExamResults = ({ curriculum, examResults } = {}) => {
  const requiredDefinitions = getRequiredExamDefinitions(curriculum);
  const results = Array.isArray(examResults) ? examResults : [];
  const resultsByDefinitionId = new Map(
    results
      .filter((exam) => !isQuizExam(exam))
      .map((exam) => [getExamDefinitionId(exam), exam])
      .filter(([definitionId]) => definitionId)
  );

  return requiredDefinitions.map((definition) => {
    const result = resultsByDefinitionId.get(getExamDefinitionId(definition));
    if (!result) return definition;

    return {
      ...definition,
      ...result,
      exam: {
        ...(definition?.exam || {}),
        ...(result?.exam || {}),
      },
    };
  });
};

export const hasPassedRequiredExams = ({ curriculum, examResults } = {}) => {
  const requiredResults = resolveRequiredExamResults({ curriculum, examResults });
  return requiredResults.length > 0 && requiredResults.every(isPassingEvaluatedExam);
};
